import { render, staticRenderFns } from "./TransportSummary.vue?vue&type=template&id=82984596&"
import script from "./TransportSummary.vue?vue&type=script&lang=js&"
export * from "./TransportSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports